export default __webpack_public_path__ + "static/media/icon_shared.195c18a7.svg";